import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { resetPassword } from "../../api/endpoints/auth";
import ContainerMd from "../../components/Layouts/ContainerMd";
import ResetPasswordForm from "../../components/forms/ResetPasswordForm";
import LoadingSpinner from "../../components/LoadingSpinner";
import { ApiResponse } from "../../api/apiResponse";
import toast from "react-hot-toast";

function PasswordResetPage() {
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const LocalBasePath = "page.passwordReset";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [token, setToken] = useState<null | string>(null);
  const [isLoading, setIsLoading] = useState(false);
  const onResetPassword = async (data: any) => {
    setIsLoading(true);
    const response: ApiResponse = await resetPassword(data.newPassword, token!);
    if (response.isSuccess) {
      navigate("/password-reset-message");
      toast.success("passwordSetSuccessfully");
      setIsLoading(false);
    } else {
      response.errorMessages.forEach((errorMessage) => {
        toast.error(errorMessage);
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setToken(searchParams.get("reset_password_token"));
  }, []);

  const Spinner = () => {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <LoadingSpinner size={16} />
      </div>
    );
  };

  return (
    <ContainerMd>
      <ResetPasswordForm
        title={t("passwordReset")}
        actionTitle={!!isLoading ? <Spinner /> : t("reset")}
        onReset={onResetPassword}
      />
    </ContainerMd>
  );
}
export default PasswordResetPage;
